export default __webpack_public_path__ + "static/media/abstract1.01e56b7e.jpg";